window.parceled = true;
import "./app.scss";

import {
  Slider,
  TypeCaptions,
  WorldMap,
  QuotesSlider,
  HeroLogos,
  AutoTabs,
  LogosRow,
} from "./components/components.js";

let isLoaded = false;

const init = () => {
  if (isLoaded) return;
  const heroLogos = new HeroLogos(
    document.querySelector(".c-hero-logos-slider")
  );
  const autoTabs = new AutoTabs(document.querySelector(".c-tabs"));
  const slider = new Slider(document.querySelector(".c-slider-out"));
  const typecaptions = new TypeCaptions();
  const worldMap = new WorldMap(document.querySelector(".c-world"));
  const quotesSlider = new QuotesSlider();
  // const logosRow = new LogosRow();

  // const headerClick = document.querySelector(".hamburger");
  // const headerMenuInner = document.querySelector(".c-header-menu-inner a");
  // for (let i = 0; i < headerMenuInner.length; i++) {
  //   headerMenuInner[i].addEventListener("click", function () {
  //     document.querySelector("body").classList.remove("has-menu");
  //   });
  // }
  // headerClick.addEventListener("click", function () {
  //   if (headerClick.classList.contains("w--open")) {
  //     document.querySelector("body").classList.remove("has-menu");
  //   } else {
  //     document.querySelector("body").classList.add("has-menu");
  //   }
  // });

  // images load trigger
  const images = document.querySelectorAll("img");
  const imagesLength = images.length;
  let imagesLoaded = 0;
  for (let i = 0; i < imagesLength; i++) {
    const image = images[i];
    image.addEventListener("load", function () {
      imagesLoaded++;
      if (imagesLoaded === imagesLength) {
        setTimeout(() => {
          window.dispatchEvent(new Event("resize"));
        }, 1000);
      }
    });
  }
  isLoaded = true;
};
document.addEventListener("DOMContentLoaded", function () {
  init();
});
init();
